import React from 'react';
import ReactDOM from 'react-dom';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

export default angular
  .module('doxy.common.directives.reactCropAdapter', [])
  .directive('dReactCropAdapter', function () {
    return {
      restrict: 'E',
      scope: {
        config: '<',
      },
      controller: function ($element, $scope) {
        let prevCrop = null;

        const render = () => {
          if (prevCrop && angular.equals(prevCrop, $scope.config.crop)) {
            return;
          }
          prevCrop = angular.copy($scope.config.crop);
          ReactDOM.render(
            React.createElement(ReactCrop, $scope.config),
            $element[0]
          );
        };
        this.$doCheck = render;
      },
    };
  }).name;
